import React, { useState, useEffect } from 'react';
import { TextField, List, ListItem, ListItemText, CssBaseline, Container, Typography, Box, Button, Grid, Link, Stepper, Step, StepLabel, CircularProgress } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Link as RouterLink, useNavigate, useLocation } from 'react-router-dom';
import { footerLinks } from '../Shared/footerLinks';
import { theme, style, config, StyledRadio } from '../../../config/settings.jsx';
import { steps } from '../../../config/steps';
import { api } from '../../../config/apis.jsx';
import { getTheme } from '../../../config/theme';
import { isInaccessible } from '@testing-library/react';

const CloseWindow = () => {
  const [subdomain, setSubdomain] = useState('');
  const [isLoadingTheme, setIsLoadingTheme] = useState(false);
  const [pageTitle, setPageTitle] = useState('Thank You!');
  const location = useLocation();
  const { cdrid } = location.state || {};
  const [stepperStep, setStepperStep] = useState(4);
  
  useEffect(() => {
    const closeWindow = () => {
      window.close();
    };

    if (window.ReactNativeWebView || window.webkit?.messageHandlers?.closeHandler || window.Android) {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (/webview|wv/i.test(userAgent) || !!window.ReactNativeWebView) {
        if (window.ReactNativeWebView && window.ReactNativeWebView.postMessage) {
          window.ReactNativeWebView.postMessage(JSON.stringify({ action: 'close' }));
        } else if (window.webkit && window.webkit.messageHandlers) {
          window.webkit.messageHandlers.closeHandler.postMessage('close');
        } else if (window.Android) {
          window.Android.closeWebView();
        }
      }
    } else {
      closeWindow();
    }
  }, []);

return (
    <ThemeProvider theme={getTheme}>
    <CssBaseline>
    <Container component="main" maxWidth="xs">
    {isLoadingTheme ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', mt: 20 }}>
          <CircularProgress />
        </Box>
      ) : (
        <>
      <Box display="flex" flexDirection="column" alignItems="center" mt={4} p={2} >
      <Grid container justifyContent="center" mb={2}>
         <Box display="flex" flexDirection="column" alignItems="center" mt={4} mb={6} style={{ width: '100%'}} >
        <Stepper activeStep={stepperStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
        </Box>
      
      <Typography variant="h4" component="h2" align="center" mt={2} sx={{fontWeight: 'bold'}} gutterBottom>
      {pageTitle}
      </Typography>
      
      <Box display="flex" flexDirection="column" alignItems="center" mt={4} mb={6} style={{ width: '100%'}}>
    
      <Typography variant="body2" component="h2" align="center"  gutterBottom>
    You can now close this window.
      </Typography>
      </Box>

      
    
      </Grid>
      



                    
      {footerLinks}
        </Box></>)}
    </Container>
    </CssBaseline> </ThemeProvider>
  );
};

export default CloseWindow;

export {};